import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import BasicLayout from "./BasicLayout";
import {registerMicroApps, start} from 'qiankun';
import "antd/dist/antd.css"
import {BrowserRouter, Routes, Route} from "react-router-dom";
import fetchJsonp from "fetch-jsonp";

//@ts-ignore
window.fetchJsonp = fetchJsonp;

registerMicroApps([
    {
        name: "usercenter",
        entry: process.env.REACT_APP_USERCENTER_APP+"?time="+new Date().getTime() as any,
        // entry: "http://localhost:7003",
        container: "#usercenter",
        activeRule: "/usercenter",
    },
    {
        name: 'publiccommunity',
        entry: process.env.REACT_APP_PUBLICCOMMUNITY_APP+"?time="+new Date().getTime() as any,
        container: '#publiccommunity',
        activeRule: '/publiccommunity',
    },
    {
        name: '/pcdataadjust',
        entry: process.env.REACT_APP_PCDATAADJUST_APP+"?time="+new Date().getTime() as any,
        container: '#pcdataadjust',
        activeRule: '/pcdataadjust',
    },
    {
        name: '/vrhouseprocessadmin',
        entry: process.env.REACT_APP_VRHOUSEPROCESSADMIN_APP+"?time="+new Date().getTime() as any,
        container: '#vrhouseprocessadmin',
        activeRule: '/vrhouseprocessadmin',
    },
    {
        name: '/modelprocess',
        entry: process.env.REACT_APP_MODELPROCESS_APP+"?time="+new Date().getTime() as any,
        container: '#modelprocess',
        activeRule: '/modelprocess',
    },
]);

start({
    excludeAssetFilter: function (url: string) {
        console.log(url,url.indexOf('js') !== -1);
        return url.indexOf('js') !== -1;
    }
});
ReactDOM.render(
    <BrowserRouter>
        <Routes>
            <Route path="*" element={<BasicLayout/>}/>
        </Routes>
    </BrowserRouter>,
    document.getElementById('root')
);
